import store from "@/store";

export class Prices {

/**
   * The price of a video appointment
   *
   * @returns {number}
   */
  static video() {
    return parseFloat(store.getters['rates/getVirtualPrice'] || 40);
  }

  /**
   * The price of an appointment outside the M25.
   *
   * @returns {number}
   */
  static outsideM25() {
    return parseFloat(store.getters['rates/getOutsideM25Price'] || 45);
  }

  /**
   * The price of an appointment inside the M25.
   *
   * @returns {number}
   */
  static insideM25() {
    return parseFloat(store.getters['rates/getInsideM25Price'] || 50);
  }

  /**
   * The price of an appointment inside central London.
   *
   * @returns {number}
   */
  static centralLondon() {
    return parseFloat(store.getters['rates/getCentralLondonPrice'] || 55);
  }

  /**
   * The price of an appointment for "exception" clinics.
   *
   * Note that this is a temporary solution to a wider pricing restructure.
   *
   * @returns {number|null}
   */
  static exception() {
    if (!process.env.VUE_APP_PRICE_EXCEPTION || !process.env.VUE_APP_EXCEPTION_CLINICS) {
      return null;
    }

    return parseFloat(process.env.VUE_APP_PRICE_EXCEPTION || 55);
  }

  /**
   * Determines if an exception price is set.
   *
   * @returns {boolean}
   */
  static hasExceptionPrice() {
    return Prices.exception() > 0;
  }

  /**
   * The "exception" clinic IDs that should use the exception price.
   *
   * @returns {Array|number[]}
   */
  static exceptionClinicIds() {
    const clinicIds = process.env.VUE_APP_EXCEPTION_CLINICS;

    if (!clinicIds) {
      return [];
    }

    return clinicIds.split(',').map(clinicId => parseInt(clinicId));
  }
}
